import { Button, Dropdown, Flex, Typography } from "antd"

import Icon from "../../../../../Icon"
import CheckMarkblue from "../../../../../Icon/img/checkMarkblue"

const { Text } = Typography

const TypesDropdown = ({
  types,
  selectedTypes = [],
  onTypesChange,
  defaultTypes = [],
  ...props
}) => {
  const handleCheckboxChange = (type, checked) => {
    const newSelectedTypes = checked
      ? [...selectedTypes, type]
      : selectedTypes.filter((t) => t !== type)
    onTypesChange?.(newSelectedTypes)
  }
  // console.log('defaultTypes', defaultTypes);

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: types
          ?.filter((type) => !defaultTypes?.includes(type?.value))
          .map((type) => ({
            key: type?.value,
            label: (
              <div
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleCheckboxChange(type?.value, !selectedTypes?.includes(type?.value))
                }}
              >
                <Flex
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    hover: { backgroundColor: "#f5f5f5" }
                  }}
                  justify="space-between"
                  align="center"
                >
                  <div>{type?.label}</div>
                  {selectedTypes?.includes(type?.value) && <CheckMarkblue />}
                </Flex>
              </div>
            )
          }))
        // style: {...props?.style}
        // style: {
        //   padding: '8px 0',
        //   borderRadius: 8,
        //   boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        // }
      }}
      dropdownRender={(menu) => <div>{menu}</div>}
    >
      <Button
        style={{
          width: "100%",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 40,
          borderRadius: 12,
          overflow: "hidden"
        }}
      >
        <Text
          type="secondary"
          title={selectedTypes?.length > 0 ? selectedTypes.join(", ") : undefined}
          style={{
            flex: 1,
            minWidth: 0,
            // antd sets `.ant-btn > span { display: inline-flex }`, and
            // text-overflow does not apply to flex containers
            display: "block",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis"
          }}
        >
          {selectedTypes?.length > 0 ? selectedTypes.join(", ") : "Select types"}
        </Text>
        <Icon
          type="chevron_down_small"
          style={{ marginLeft: -4, marginRight: -4, flexShrink: 0 }}
        />
      </Button>
    </Dropdown>
  )
}

export default TypesDropdown
